import { styled } from '@mui/material/styles'
import {
  Box,
  Drawer as MuiDrawer,
  ListItem,
  ListItemButton,
} from '@mui/material'

export const DrawerHeader = styled(Box, {
  shouldForwardProp: (props) => props !== 'isSidebarOpen',
})<{ isSidebarOpen: boolean }>(({ isSidebarOpen, theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: isSidebarOpen ? '100%' : '20px',
  marginBottom: theme.spacing(2),
  flexShrink: 0,
  height: '42px',
}))

export const SidebarHeader = styled('h4', {
  shouldForwardProp: (props) => props !== 'isSidebarOpen',
})<{ isSidebarOpen: boolean }>(({ theme }) => ({
  textTransform: 'uppercase',
  transition: '0.2s ease-in-out margin-left',
  fontSize: '10px',
  color: theme.palette.text.secondary,
  fontWeight: 'bold',
}))

export const Drawer = styled(MuiDrawer)(({ theme, open }) => ({
  flexBasis: '40px',
  flexGrow: 0,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.secondary.main,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    width: open ? theme.spacing(33) : theme.spacing(5),
    alignItems: open ? 'flex-start' : 'center',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '5px' },
    '&::-webkit-scrollbar-thumb': {
      width: '5px',
      backgroundColor: theme.palette.neutral.grey6,
      borderRadius: '5px',
      flex: ' 0 0 auto',
    },
    [theme.breakpoints.between('xs', 'sm')]: {
      width: open ? '100%' : theme.spacing(5),
    },
  },
}))

export const SidebarListItem = styled(ListItem)`
  text-decoration: none;
`

export const ListButton = styled(ListItemButton, {
  shouldForwardProp: (props) =>
    props !== 'isSelected' && props !== 'isSidebarOpen',
})<{ isSelected: boolean; isSidebarOpen: boolean }>(
  ({ isSelected, isSidebarOpen, theme }) => ({
    borderRadius: '5px',
    marginLeft: isSidebarOpen ? '17px' : 0,
    transition: '0.2s ease-in-out margin-left',
    padding: theme.spacing(1),
    textDecoration: 'none',
    display: 'block',
    maxWidth: '230px',
    maxHeight: '40px',
    fontSize: theme.typography.body1.fontSize,
    color: isSelected ? theme.palette.primary.main : theme.palette.text.primary,
    backgroundColor:
      isSelected && isSidebarOpen
        ? theme.palette.commonColors.white
        : 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.commonColors.white,
      '#icon': {
        transition: '0.2s ease-in-out fill',
        fill: theme.palette.icon.hover,
      },
    },
    '*': {
      fill: isSelected ? theme.palette.icon.selected : '',
    },
    justifyContent: isSidebarOpen ? 'initial' : 'center',
    px: 1,
    '.MuiTypography-root': {
      fontWeight: isSelected ? 'bold' : 'normal',
    },
    '.MuiSvgIcon-root': {
      fill: isSelected ? theme.palette.icon.selected : theme.palette.icon.main,
      '&:hover': { fill: theme.palette.icon.hover },
    },
  })
)
